import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum LeadRouteNames {
  LEAD_TABLE = "LEAD_TABLE",
  LEAD_DETAIL = "LEAD_DETAIL",
  LEAD_GROUP_TABLE = "LEAD_GROUP_TABLE",
  LEAD_GROUP_DETAIL = "LEAD_GROUP_DETAIL",
  LEAD_GROUP_CUSTOM_VIEW = "LEAD_GROUP_CUSTOM_VIEW"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Lead = { leadId: string };
type LeadGroup = { leadGroupId: string };
type View = { viewId: string };
type Query = { query?: Record<string, string> };

export class LeadGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = LeadGoToHelper.locations;

    return {
      LeadTable: (partnerId: string) => ({
        text: $t("nav.LEAD_TABLE.title").toString(),
        exact: true,
        to: locations.leadTable({ partnerId })
      }),
      LeadDetail: (partnerId: string, leadId: string) => ({
        text: $t("nav.LEAD_DETAIL.title").toString(),
        exact: true,
        to: locations.leadDetail({ partnerId, leadId })
      }),
      LeadGroupTable: (partnerId: string) => ({
        text: $t("lead.leadGroups").toString(),
        exact: true,
        to: locations.leadGroupTable({ partnerId })
      }),
      LeadGroupCustomView: (partnerId: string, leadGroupId: string, viewId?: string) => ({
        text: $t("lead.leadGroup").toString(),
        exact: true,
        to: locations.leadGroupCustomView({ partnerId, leadGroupId, viewId: viewId ?? "0" })
      }),
      LeadGroupDetail: (partnerId: string, leadGroupId: string) => ({
        text: $t("common.verbs.edit").toString(),
        exact: true,
        to: locations.leadGroupDetail({ partnerId, leadGroupId })
      })
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    leadTable: (d: Partner & Query) => ({
      name: LeadRouteNames.LEAD_TABLE,
      params: { partnerId: d.partnerId },
      query: d.query
    }),
    leadDetail: (d: Partner & Lead & Query) => ({
      name: LeadRouteNames.LEAD_DETAIL,
      params: { partnerId: d.partnerId, leadId: d.leadId },
      query: d.query
    }),
    leadGroupTable: (d: Partner & Query) => ({
      name: LeadRouteNames.LEAD_GROUP_TABLE,
      params: { partnerId: d.partnerId },
      query: d.query
    }),
    leadGroupDetail: (d: Partner & LeadGroup & Query) => ({
      name: LeadRouteNames.LEAD_GROUP_DETAIL,
      params: { partnerId: d.partnerId, leadGroupId: d.leadGroupId },
      query: d.query
    }),
    leadGroupCustomView: (d: Partner & LeadGroup & View & Query) => ({
      name: LeadRouteNames.LEAD_GROUP_CUSTOM_VIEW,
      params: { partnerId: d.partnerId, leadGroupId: d.leadGroupId, viewId: d.viewId },
      query: d.query
    })
  };

  goToLeadTable(d: Tab & Partner) {
    this.go(LeadGoToHelper.locations.leadTable(d), d.newTab);
  }
  goToLeadDetail(d: Tab & Partner & Lead) {
    this.go(LeadGoToHelper.locations.leadDetail(d), d.newTab);
  }
  goToLeadGroupTable(d: Tab & Partner) {
    this.go(LeadGoToHelper.locations.leadGroupTable(d), d.newTab);
  }
  goToLeadGroupDetail(d: Tab & Partner & LeadGroup) {
    this.go(LeadGoToHelper.locations.leadGroupDetail(d), d.newTab);
  }
  goToLeadGroupCustomView(d: Tab & Partner & LeadGroup & View) {
    this.go(LeadGoToHelper.locations.leadGroupCustomView(d), d.newTab);
  }
}
